import AdjustmentManager from "@/pages/adjustments/manager";
import AdjustmentReport from "@/pages/adjustments/report";

export const routeAdjustmentManager = "/adjustments/manager";
export const routeAdjustmentReport = "/adjustments/report";
export const adjustmentsManagerPermission = "ui.navbar.adjustments.manager";
export const adjustmentsReportPermission = "ui.navbar.adjustments.report";

export const adjustmentRoutes = [
	{
		path: `${routeAdjustmentManager}`,
		element: <AdjustmentManager />,
		permission: adjustmentsManagerPermission,
	},
	{
		path: `${routeAdjustmentManager}/:shiftId`,
		element: <AdjustmentManager />,
		permission: adjustmentsManagerPermission,
	},
	{
		path: `${routeAdjustmentReport}`,
		element: <AdjustmentReport />,
		permission: adjustmentsReportPermission,
	},
];
